<script>
export default {
  name: "s-progress",
  props: {
    value: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      default: 100,
    },
  },
};
</script>

<template>
  <progress :value="value" :max="max"></progress>
</template>

<style scoped>
progress {
  --default-bar-color: #3d84c6;
  --default-bar-background-color: #dbdae3;

  width: 100%;
  border: none;
  position: relative;
  accent-color: var(--bar-color, var(--default-bar-color));
  appearance: none;
  overflow: hidden;
  -webkit-appearance: none;
}

progress,
::-webkit-progress-bar {
  background-color: var(--bar-background-color,
      var(--default-bar-background-color));
}

::-webkit-progress-value {
  background-color: var(--bar-color, var(--default-bar-color));
}

::-moz-progress-bar {
  background-color: var(--bar-color, var(--default-bar-color));
}

progress,
::-webkit-progress-bar,
::-webkit-progress-value {
  border-radius: 12px;
}
</style>